import SectionMixin from '@/mixins/sectionMixin'

//formulajs calc
import {IRR, NOMINAL} from '@formulajs/formulajs'

export default {
    name: 'vtu-simulator-credit',
    mixins: [SectionMixin],
    props:{
        type: String,
        title: String,
        subtitle: String,
        infoField: String,
        warningField: String,
        tooltip: {},
        info: {},
    },
    
    data: ()=>{
        return {
            amount: 0,
            total: Number,

            eaRateCredit: Number,

            safe: 0.034,
            months: Number,

            showError: false,
            showErrorSelectedAccount: false,
            vtuClosed: true,
            selectMonth: "",
            CreditOptions: [],
            CreditCardOptions: []
        }
    },
    beforeMount(){
        this.wording = this.$store.state.wording.data.attributes

        if(this.$store.state.page["vtu-credit"]){
            this.EAnumberCredit = this.$store.state.page["vtu-credit"].data.attributes.simulator.ea_rate
            this.eaRateCredit = this.EAnumberCredit
        }else if(this.$store.state.page["vtu-credit-card"]){
            this.EAnumberCredit = this.$store.state.page["vtu-credit-card"].data.attributes.simulator.ea_rate
            this.eaRateCredit = this.EAnumberCredit
        }
    },
    mounted() {

        this.CreditOptions = this.generateOptions(12,48,6)
        this.CreditCardOptions = this.generateOptions(1,36,1)

        this.$el.addEventListener("submit", (evt)=>{
            evt.preventDefault()
            this.checkForm()
        })

        this.$refs["vtu-amount"].addEventListener("change", ()=>{

            this.inputValue = this.$refs["vtu-amount"].value
            let inputValueNumber = Number(this.inputValue).toLocaleString("en-US")
            let sourceLabel = document.querySelector('.form-group-label')
            if(this.inputValue){
                sourceLabel.innerHTML = inputValueNumber
            }else{
                sourceLabel.innerHTML = ''
            }

        })
    },

    methods: {
        saveUrlToScroll(url,id) {
            localStorage.setItem('scrollToElementId',id);
            this.$router.push(url);
        },
        generateOptions: function (start, max, jumps) {
            let options = [];
            for (let i = start; i <= max; i += jumps) {
                options.push({
                    text: `${i} ${i === 1 ? 'Mes' : 'Meses'}`,
                    value: i
                })
            }
            return options;
        },
        onChange(id){
            if (id === "radio-group") {
                this.showErrorSelectedAccount = !this.selectedAccountRate;
            }
        },
        checkForm: function (type) {
            this.inputValue = this.$refs["vtu-amount"].value

            if(type === 'credit'){
                if(this.inputValue && this.selectMonth){
                    this.amount = Number(this.inputValue)
                    this.months = this.selectMonth

                    if(this.amount > 50000000 ){
                        this.showError = true
                        this.vtuClosed = true
                    }else{
                        this.showError = false
                        this.vtuClosed = false
                    }
                }
            }else{
                if(this.inputValue && this.selectMonth && this.selectedAccountRate){
                    this.amount = Number(this.inputValue)
                    this.months = this.selectMonth
                    this.showError = false
                    this.showErrorSelectedAccount = false
                    this.vtuClosed = false
                }
                if(!this.selectedAccountRate){
                    this.showErrorSelectedAccount = true
                }
            }
        },
/*------------------------Credit----------------------------*/
        calculateIN: function(eaRateCredit){
            const nominal = Number((Math.pow(1 + eaRateCredit/100,1/12) - 1)*12);
            return nominal
        },
        calculateMV2: function(nominal){
            return (nominal/12)*100;
        },
        calculateSP: function(safe,MV2){
            return MV2+safe;
        },
        calculateEA2: function(SP){
            return Number(Math.pow(1+(SP/100),12)-1)
        },
        calculatePMT: function(amount,SP,months){
            return Number(amount * ( (Math.pow(1+SP/100, months)*SP/100) / (Math.pow(1+SP/100, months)-1) ) )
        },
        calculatePMTfor: function(PMT,months){
            return PMT * months;
        },
        calculatePMTminus: function(PMT,amount){
            return PMT - amount;
        },
        calculateS: function(safe,SP,PMTm){
            return (safe/SP)*PMTm;
        },
        calculateI: function(PMTm,secures){
            return PMTm-secures;
        },
    },

    computed:{
        /*------------------------Credit----------------------------*/
        nominal(){
            return this.calculateIN(this.eaRateCredit)
        },
        MV2(){
            return this.calculateMV2(this.nominal)
        },
        SP(){
            return this.calculateSP(this.safe,this.MV2)
        },
        EA2(){
            return this.calculateEA2(this.SP)
        },
        PMT(){
            return this.calculatePMT(this.amount,this.SP,this.months)
        },
        PMTf(){
            return this.calculatePMTfor(this.PMT, this.months)
        },
        PMTm(){
            return this.calculatePMTminus(this.PMTf, this.amount)
        },
        secure(){
            return this.calculateS(this.safe,this.SP,this.PMTm)
        },
        interests(){
            return this.calculateI(this.PMTm, this.secure)
        },
    }
}